import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import routeConfige from "../config/index";
import routeConfigePages from "../config/pages";




const RouterProvider = () => (
   <Suspense fallback='...'>
       
    <Routes>
        {
            Object.values(routeConfige).map(({path, element}) => (
                <Route
                    key={path}
                    path={path}
                    element={element}
                />
            ))
        }
            {
            Object.values(routeConfigePages).map(({path, element, category}) => (
                <Route
                    key={path}
                    path={path}
                    element= {element}
                   
                />
            ))
        }


    </Routes>
   </Suspense>
)
 
export default RouterProvider;